export const billingAccountConstants = {
  CREATE_BILLINGACCOUNT: 'CREATE_BILLINGACCOUNT',
  RETRIEVE_BILLINGACCOUNTS: 'RETRIEVE_BILLINGACCOUNTS',
  UPDATE_BILLINGACCOUNT: 'UPDATE_BILLINGACCOUNT',
  DELETE_BILLINGACCOUNT: 'DELETE_BILLINGACCOUNT',
  DELETE_ALL_BILLINGACCOUNT: 'DELETE_ALL_BILLINGACCOUNT',
}
